import {Component, OnInit} from '@angular/core';
import {DynamicDialogRef} from "primeng/dynamicdialog";
import {InputTextModule} from "primeng/inputtext";
import {FormsModule} from "@angular/forms";
import {DialogModule} from "primeng/dialog";
import {ButtonModule} from "primeng/button";
import {ProfileDetails} from "../../../api/models";
import { AppraiserUtilsService } from "../../services/utils";
import { TagModule } from 'primeng/tag';

@Component({
  selector: 'app-profile',
  standalone: true,
  imports: [
    InputTextModule,
    FormsModule,
    DialogModule,
    ButtonModule, TagModule
  ],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit {
  profileDetails: ProfileDetails | undefined = {};

  constructor(public ref: DynamicDialogRef, private utilityService: AppraiserUtilsService) {
  }

  ngOnInit(): void {
    this.utilityService.profileDetails$.pipe().subscribe({
      next: (res) => {
        this.profileDetails = res;
      }
    })
  }

  close() {
    this.ref.close();
  }
}
